"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

/** Field label above the control: 12 px muted (UI.md §6). */
function Label({ className, ...props }: React.ComponentProps<"label">) {
  return (
    <label
      data-slot="label"
      className={cn("flex items-center gap-2 text-label font-medium text-muted-foreground select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-60", className)}
      {...props}
    />
  )
}

export { Label }
